// extracted by mini-css-extract-plugin
module.exports = {"list_table":"styles_list_table__3mM3B","actions_icons":"styles_actions_icons__3j4uw"};